import * as actions from '../constants'

const cachedUser = localStorage.getItem("user")

const inititalState = {
  postFormOpening: false,
  commentFormOpening: false,
  my: cachedUser?JSON.parse(cachedUser):{},
  myPostLikes: {},
  showIntro: localStorage.getItem("visited")?false:true,
  myCommentLikes: {},
  myComments: {},
  postInput: {},
  commentInput: {},
  posts: {},
  users: {},
  activePost: null,
  initial: false,
  loadingMy: cachedUser?false:true,
  loadingMyError: null,
  loadingUser: true,
  loadingUserError: null,
  loadingPosts: true,
  loadingPostsError: null,
  loadingLikes: true,
  loadingLikesError: null,
  loadingComments: true,
  loadingCommentsError: null,
}

export default (state = inititalState, action) => {
  switch (action.type) {
    case actions.LOAD_POSTS_REQUEST:
      return {
        ...state,
        // postFormOpening: false,
        // commentFormOpening: false,
      }
    case actions.LOAD_MY_REQUEST:
      return {
        ...state,
        my: null,
        loadingMy: true,
        loadingMyError: null
      }
    case actions.LOAD_MY_SUCCESS:
      localStorage.setItem("user", JSON.stringify(action.payload))
      return {
        ...state,
        my: action.payload,
        loadingMy: false,
        loadingMyError: null
      }
    case actions.LOAD_MY_FAILURE:
      return {
        ...state,
        loadingUser: false,
        loadingUserError: action.payload
      }
    case actions.LOAD_USER_REQUEST:
    {
      let users = {...state.users}
      users[action.payload._id] = null
      return {
        ...state,
        users,
        loadingUser: true,
        loadingUserError: null
      }
    }
    case actions.LOAD_USER_SUCCESS:
      let users = {...state.users}
      users[action.payload._id] =  action.payload.user
      return {
        ...state,
        users,
        loadingUser: false,
        loadingUserError: null
      }
    case actions.LOAD_USER_FAILURE:
      return {
        ...state,
        loadingUser: false,
        loadingUserError: action.payload
      }
    case actions.LOAD_USER_POSTS_REQUEST: {
      let posts = {...state.posts}
      posts[action.payload._id] = []
      return {
        ...state,
        posts,
        loadingPosts: true,
        loadingPostsError: null
      }
    }
    case actions.LOAD_USER_POSTS_SUCCESS: {
      let posts = {...state.posts}
      posts[action.payload._id] = action.payload.posts
      return {
        ...state,
        posts,
        loadingPosts: false,
        loadingPostsError: null
      }
    }
    case actions.LOAD_USER_POSTS_FAILURE:
      return {
        ...state,
        loadingPosts: false,
        loadingPostsError: action.payload
      }
    case actions.CREATE_POST_REQUEST:
      return {
        ...state,
        postInput: {
          content: '',
          anonymous: false
        }
      }
    case actions.CREATE_POST_SUCCESS:
    {
      let posts = {...state.posts}
      let {post, user} = action.payload
      posts[state.my._id] = posts[state.my._id]?posts[state.my._id].slice():[]
      posts[state.my._id].unshift(post)
      localStorage.setItem("user", JSON.stringify(user))
      return {
        ...state,
        posts,
        activePost: post._id,
        my:user,
        // postFormOpening: false,
        // commentFormOpening: false,
        postInput: {
          content: '',
          anonymous: false
        }
      }
    }
    case actions.CREATE_POST_LIKE_SUCCESS:
    {
      let posts = {...state.posts}
      let myPostLikes = {...state.myPostLikes}
      let {post, user, like} = action.payload
      posts[user._id] = posts[user._id]?posts[user._id].slice():[]
      posts[user._id].map((p, index)=>{
        if(p._id == post._id){
          posts[user._id][index] = post
        }
      })
      myPostLikes[post._id] = like
      localStorage.setItem("user", JSON.stringify(user))
      return {
        ...state,
        posts,
        myPostLikes,
        my:user,
      }
    }
    case actions.CREATE_COMMENT_REQUEST:
      console.log(actions.CREATE_COMMENT_REQUEST)
      return {
        ...state,
        commentInput: {
          content: '',
          anonymous: false
        }
      }
    case actions.CREATE_COMMENT_SUCCESS: {
      let {user} = action.payload
      localStorage.setItem("user", JSON.stringify(user))
      return {
        ...state,
        my:user,
        // postFormOpening: false,
        // commentFormOpening: false,
        commentInput: {
          content: '',
          anonymous: false
        }
      }
    }
    case actions.CREATE_COMMENT_LIKE_SUCCESS:
    {
      let myComments = {...state.myComments}
      let myCommentLikes = {...state.myCommentLikes}
      let {comment, user, like} = action.payload
      let comments = myComments.comments.slice()
      comments.forEach((c, index)=>{
        if(c._id === comment._id){
          comments[index] = comment
        }
      })
      myCommentLikes[comment._id] = like
      localStorage.setItem("user", JSON.stringify(user))
      return {
        ...state,
        myComments: {
          ...myComments,
          comments
        },
        myCommentLikes,
        my:user,
      }
    }
    case actions.DELETE_POST_SUCCESS: {
      let posts = {...state.posts}
      posts[state.my._id] = posts[state.my._id]?posts[state.my._id]:[]
      posts[state.my._id] = posts[state.my._id].filter(p=>p._id != action.payload)
      return {
        ...state,
        posts,
      }
    }
    case actions.TOGGLE_POST_FORM:
      return {
        ...state,
        postFormOpening: !state.postFormOpening
      }
    case actions.TOGGLE_COMMENT_FORM:
      return {
        ...state,
        commentFormOpening: !state.commentFormOpening
      }
    case actions.UPDATE_COMMENT_INPUT:
      return {
        ...state,
        commentInput: {...state.commentInput, ...action.payload}
      }
    case actions.UPDATE_POST_INPUT:
      return {
        ...state,
        postInput: {...state.postInput, ...action.payload}
      }
    case actions.LOAD_MY_COMMENTS_REQUEST: {
      return {
        ...state,
        myComments: {},
        loadingComments: true,
        loadingCommentsError: null
      }
    }
    case actions.LOAD_MY_COMMENTS_SUCCESS: {
      return {
        ...state,
        myComments: action.payload,
        loadingComments: false,
        loadingCommentsError: null
      }
    }
    case actions.LOAD_MY_COMMENTS_FAILURE:
      return {
        ...state,
        loadingComments: false,
        loadingCommentsError: action.payload
      }
    case actions.LOAD_MY_LIKES_REQUEST: {
      return {
        ...state,
        myCommentLikes:{},
        myPostLikes:{},
        loadingLikes: true,
        loadingLikesError: null
      }
    }
    case actions.LOAD_MY_LIKES_SUCCESS: {
      let myPostLikes = {...state.myPostLikes}
      let myCommentLikes = {...state.myCommentLikes}
      action.payload.likes.forEach(like=>{
        if(like.post){
          myPostLikes[like.post] = like
        }
        if(like.comment){
          myCommentLikes[like.comment] = like
        }
      })
      return {
        ...state,
        myPostLikes,
        myCommentLikes,
        loadingLikes: false,
        loadingLikesError: null
      }
    }
    case actions.LOAD_MY_LIKES_FAILURE:
      return {
        ...state,
        loadingLikes: false,
        loadingLikesError: action.payload
      }
    case actions.ACTIVE_POST:
      return {
        ...state,
        activePost: action.payload
      }
    case actions.TOGGLE_INTRO:
      if(state.showIntro){
        localStorage.setItem("visited", "yes")
      }
      return {
        ...state,
        showIntro: !state.showIntro
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js